module.exports = function (options)
{

    return {
        ...options,

        // Overwrite options
        // language: 'en',
        language: 'nl',

        // Add styles
        stylesSet: [
            { name: 'Normal', element: 'span', attributes: {'class': ''}},

            { name: 'Heading 1', element: 'p', attributes: { 'class': 'h1' } },
            { name: 'Heading 2', element: 'p', attributes: { 'class': 'h2' } },
            { name: 'Heading 3', element: 'p', attributes: { 'class': 'h3' } },
            { name: 'Heading 4', element: 'p', attributes: { 'class': 'h4' } },
            { name: 'Heading 5', element: 'p', attributes: { 'class': 'h5' } },

            { name: 'Groot tekst', element: 'p', attributes: { 'class': 'text-xl md:text-3xl text-centuryGothic' } },
            { name: 'Extra groot tekst', element: 'p', attributes: { 'class': 'text-3xl md:text-5xl font-bold text-centuryGothic' } },

            { name: 'Grote (100px) titel', element: 'span', attributes: { 'class': 'text-5xl md:text-[100px]' } },

            { name: 'Primary button', element: 'a', attributes: { class: 'btn-primary' } },
        ],

        // Allow tags.
        format_tags: 'p;h1;h2;h3;h4;h5',

    };

};
